import { ImportFileFormat } from "../models/models.swagger.generated";


export class FileFormatHelper {
  public static getAllowedFileExtensions(fileFormat: ImportFileFormat): string {
    switch (fileFormat)
    {
      case ImportFileFormat.CSV:
      {
          return '.csv';
      }
      case ImportFileFormat.XML:
      {
          return '.xml';
      }
      case ImportFileFormat.XLS:
      {
          return '.xls';
      }
      case ImportFileFormat.XLSX:
      {
          return '.xlsx';
      }
      case ImportFileFormat.JSON:
      {
          return '.json';
      }
      case ImportFileFormat.EDIFACT:
      {
          return '.edi,.xml';
      }
      case ImportFileFormat.PDF:
      {
          return '.pdf';
      }
      case ImportFileFormat.Acodis:
      {
          return '.xml';
      }
      default:
      {
        return '.xml,.xlsx,.csv,.json,.edi';
      }
    }
  }

  public static getAllowedFileExtensionsForCorrectionFiles(fileFormat: ImportFileFormat): string {
    if (fileFormat === ImportFileFormat.PDF) {
      fileFormat = ImportFileFormat.Acodis;
    }
    return FileFormatHelper.getAllowedFileExtensions(fileFormat);
  }
}
